import {Service} from "platform/service/Service";
import {Reducer} from "platform/redux/Reducer";
import {ServiceType} from "enum/ServiceType";
import NewsEngine from "core/engine/NewsEngine";
import NewsReducer from "core/redux/news/NewsReducer";

export class NewsService implements Service<NewsEngine, any> {

    private static _instance: NewsService;

    private constructor() {
    }

    public static instance(): NewsService {
        return this._instance || (this._instance = new this());
    }

    public async setup<Props>(props?: Props): Promise<void> {
    }

    public name(): string {
        return ServiceType.News;
    }

    public reducers(): Array<Reducer<any>> {
        return [NewsReducer.instance()];
    }

    public engine(): NewsEngine {
        return NewsEngine.instance();
    }

    public state(): any {
        return undefined;
    }
}
